export let dataProps = {
    id: 0,
    first_name: '',
    last_name: '',
    brand_name: '',
    
    rep_id: null,
    temp_handler_rep_id: null,
    discussion_logs: [],
    contact_number_list: [],
    allow_addition_of_store: 0,

    country_id: 0,
    email_address: '',
    tailoring_category: 0,
    trial_account: true,
    coupon_code: '',
    flat_rate: false,
    send_notification: true,
    paid_account: true,
    visible: true,
    google_sync_enabled: false,
}


// WEBPACK FOOTER //
// ./src/store/modules/tenants/properties.js